/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint-disable no-dupe-keys */
// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

const { gradients } = colors;

function configs(labels, datasets, count) {
  const backgroundColors = [];

  if (datasets.backgroundColors) {
    datasets.backgroundColors.forEach((color, index) => {
      if (gradients[color]) {
        // if (index === 0) {
        //   backgroundColors.push(gradients[color].main);
        // } else {
          backgroundColors.push(gradients[color].state);
        // }
      } else {
        backgroundColors.push(gradients.info.main);
      }
    });
  } else {
    backgroundColors.push(gradients.info.main);
  }

  // const centerTextDoughnut = {
  //   id: 'centerTextDoughnut',
  //   afterDatasetsDraw(chart, args, pluginOptions) {
  //     const { ctx } = chart;
  //     ctx.textAlign = 'center';
  //     ctx.font = 'bold 32px Roboto';
  //     ctx.textBaseline = 'middle';
  //     const text = count;

  //     const x = chart.getDatasetMeta(0).data[0].x;
  //     const y = chart.getDatasetMeta(0).data[0].y;

  //     ctx.fillText(text, x, y);
  //   },
  //   legend: false
  // }

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          weight: 9,
          cutout: '70%',
          tension: 0.9,
          pointRadius: 2,
          borderWidth: 2,
          backgroundColor: backgroundColors,
          fill: true,
          data: datasets.data,
        },
      ],
    },
    options: {
      responsive: true,
      aspectRatio: 2.4,
      maintainAspectRatio: true,
      plugins: {
        legend: false
      }, 
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    },
    // plugins: [centerTextDoughnut]
  };
}

export default configs;